import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Skeleton from '../../../componentsv2/Skeleton';
import Layout from '../../../componentsv2/Layout';
import { COLORS } from '../../../themev2';

export default function BankingPageCardsSkeleton() {
  return (
    <Layout>
      <Grid container spacing={3}>
        {/* Header Section */}
        <Grid item xs={8}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Skeleton variant="rectangular" width={120} height={32} animation="wave" />
            </Grid>
            <Grid item xs={12}>
              <Skeleton variant="text" width={300} height={24} animation="wave" />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Skeleton variant="rectangular" width={100} height={40} animation="wave" />
          <Skeleton variant="rectangular" width={100} height={40} animation="wave" />
        </Grid>

        {/* Tabs */}
        <Grid item xs={12}>
          <Box>
            <Grid container spacing={2}>
              {['All', 'Company', 'Employee'].map((_, index) => (
                <Grid item key={index}>
                  <Skeleton variant="rectangular" width={100} height={32} animation="wave" />
                </Grid>
              ))}
              <Grid item xs={12}>
                <Divider sx={{ borderColor: COLORS.gray[600] }} />
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {/* Table */}
        <Grid item xs={12}>
          <Box
            sx={{
              backgroundColor: '#fff',
              borderRadius: '12px',
              overflow: 'hidden',
            }}
          >
            {/* Table Header */}
            <Grid container sx={{ backgroundColor: '#f8fafc', p: 2 }}>
              <Grid item xs={1.5}>
                <Skeleton variant="text" width="80%" height={24} animation="wave" />
              </Grid>
              <Grid item xs={1.5}>
                <Skeleton variant="text" width="80%" height={24} animation="wave" />
              </Grid>
              <Grid item xs={2}>
                <Skeleton variant="text" width="80%" height={24} animation="wave" />
              </Grid>
              <Grid item xs={1.5}>
                <Skeleton variant="text" width="80%" height={24} animation="wave" />
              </Grid>
              <Grid item xs={1.5}>
                <Skeleton variant="text" width="80%" height={24} animation="wave" />
              </Grid>
              <Grid item xs={2.5}>
                <Skeleton variant="text" width="80%" height={24} animation="wave" />
              </Grid>
              <Grid item xs={1.5}>
                <Skeleton variant="text" width="80%" height={24} animation="wave" />
              </Grid>
            </Grid>

            {/* Table Rows */}
            {[1, 2, 3, 4, 5, 6, 7, 8].map((row) => (
              <Grid container key={row} sx={{ p: 2, borderBottom: '1px solid #f1f5f9' }}>
                <Grid item xs={1.5}>
                  <Skeleton variant="text" width="80%" height={24} animation="wave" />
                </Grid>
                <Grid item xs={1.5}>
                  <Skeleton variant="text" width="80%" height={24} animation="wave" />
                </Grid>
                <Grid item xs={2}>
                  <Skeleton variant="text" width="80%" height={24} animation="wave" />
                </Grid>
                <Grid item xs={1.5}>
                  <Skeleton variant="text" width="80%" height={24} animation="wave" />
                </Grid>
                <Grid item xs={1.5}>
                  <Skeleton variant="text" width="80%" height={24} animation="wave" />
                </Grid>
                <Grid item xs={2.5}>
                  <Skeleton variant="text" width="80%" height={24} animation="wave" />
                </Grid>
                <Grid item xs={1.5}>
                  <Skeleton variant="rectangular" width="60%" height={24} animation="wave" />
                </Grid>
              </Grid>
            ))}

            {/* Pagination */}
            <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
              <Skeleton variant="circular" width={32} height={32} animation="wave" />
              <Skeleton variant="circular" width={32} height={32} animation="wave" />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Layout>
  );
}
